<template>
  <section class="section-hero section-shaped my-0">
    <div class="shape shape-style-1 shape-primary">
      <span class="span-150"></span>
      <span class="span-50"></span>
      <span class="span-50"></span>
      <span class="span-75"></span>
      <span class="span-100"></span>
      <span class="span-75"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
    </div>
    <div class="container shape-container d-flex align-items-center">
      <div class="col px-0">
        <div class="row justify-content-center align-items-center pb-lg-1">
          <div class="col-lg-8 text-center mt-lg-1 mb-lg-5">
            <div align="center">
              <p class="lead text-white mt-4 mb-1">
                <!--img 
                src="img/brand/white.png" 
                style="width: 200px; margin-bottom: 10px;" 
                class="img-fluid" /-->
                <span style="font-weight: bold">
                  <font size="7"> <i> Robots, jobs, and resilience</i></font>
                </span>
              </p>
            </div>
            <p class="lead text-white mt-4 mb-1">
              <font size="4"
                >Check the automation risk of your job, learn how to reuse your
                abilities</font
              >
            </p>
            <div class="btn-wrapper">
              <auto-complete
                alternative
                placeholder="Job Name"
                addon-left-icon="ni ni-zoom-split-in"
                addon-right-icon="ni ni-bold-down"
                :options="options"
                @select-item="onOptionSelect"
              ></auto-complete>

              <base-button
                tag="a"
                href="#"
                @click="onOptionSelect('')"
                class="mb-3 mb-sm-0"
                >Check & Learn</base-button
              >

              <!-- <base-button
                tag="a"
                href="https://www.creative-tim.com/product/vue-argon-design-system"
                class="mb-3 mb-sm-0"
                type="white"
                icon="ni ni-cloud-download-95"
              >Download Vue</base-button>-->
            </div>
          </div>
        </div>
        <div class="row align-items-center justify-content-around mt-5">
          <div class="col-sm-6" align="center">
            <p class="lead text-white mt-4 mb-1">
              <font size="4">Brought to you by</font>
            </p>
            <p class="lead text-white mt-4 mb-1">
              <a
                href="https://lis.epfl.ch/"
                target="_blank"
                title="Laboratory of Intelligent Systems"
              >
                <img
                  src="img/brand/EPFL.png"
                  style="
                    height: 40px;
                    margin-top: 5px;
                    margin-left: 0px;
                    margin-right: 15px;
                  "
                />
              </a>
              <!-- <font size="4">&</font> -->
              <a
                href="http://www.lalive.org/"
                target="_blank"
                title="Laboratory of Intelligent Systems"
              >
                <img
                  src="img/brand/unil.png"
                  style="
                    height: 40px;
                    margin-top: 5px;
                    margin-left: 15px;
                    margin-right: 0px;
                  "
                />
              </a>
            </p>
          </div>
        </div>
        <div class="row align-items-center justify-content-around mt-5">
          <div class="col-sm-40" align="center">
            <p class="lead text-white mt-4 mb-1">
              <font size="4">Funded by</font>
            </p>
            <p class="lead text-white mt-4 mb-1">
              <a href="https://www.epfl.ch/en/" target="_blank" title="EPFL">
                <img
                  src="img/brand/EPFL.png"
                  style="
                    height: 40px;
                    margin-top: 5px;
                    margin-left: 0px;
                    margin-right: 15px;
                  "
                />
              </a>
              <!-- <font size="4">&</font> -->
              <a href="https://unil.ch/index.html" target="_blank" title="UNIL">
                <img
                  src="img/brand/unil.png"
                  style="
                    height: 40px;
                    margin-top: 5px;
                    margin-left: 15px;
                    margin-right: 0px;
                  "
                />
              </a>
              <a href="https://www.snf.ch/" target="_blank" title="UNIL">
                <img
                  src="img/brand/SNF_logo.png"
                  style="
                    height: 40px;
                    margin-top: 5px;
                    margin-left: 15px;
                    margin-right: 0px;
                  "
                />
              </a>
              <a
                href="https://cordis.europa.eu/"
                target="_blank"
                title="UNIL"
              >
                <img
                  src="img/brand/euro_logo.png"
                  style="
                    height: 40px;
                    margin-top: 5px;
                    margin-left: 15px;
                    margin-right: 0px;
                  "
                />
              </a>
              <a
                href="https://e4s.center/"
                target="_blank"
                title="UNIL"
              >
                <img
                  src="img/brand/e4s_logo2.png"
                  style="
                    height: 40px;
                    margin-top: 5px;
                    margin-left: 15px;
                    margin-right: 0px;
                  "
                />
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import AutoComplete from "./AutoComplete";

import occupationRisks from "../../analytics/occupation_risk.json";
export default {
  components: {
    AutoComplete,
  },
  data() {
    return {
      options: occupationRisks,
    };
  },
  methods: {
    onOptionSelect(option) {
      if (option == "") {
        console.log("No Option Selected");
      } else {
        this.$router.push({ name: "profile", params: { occupation: option } });
      }
      console.log(option);
    },
  },
};
</script>
<style>
.bottom-right {
  position: absolute;
  bottom: 15px;
  right: 15px;
}
</style>
